<template>
  <div class="">
    <div class="top-search-box">
      <topTab :rout="rout"></topTab>
    </div>
    <div class="content">

    <img class="page-logo" src="@/assets/home/1.png" alt="" />

    <div class="title">
      <div class="title-line"></div>
      <span>称骨算命</span>
    </div>
    <div class="text">
      <p>
        相传是唐朝周易大师袁天罡先生所创,其法将人的生辰八字,即出生的农历年月日时计算相应的“骨重”的总值来进行算命。
      </p>
    </div>
    <div class="sex">
      <div :class="{ action: sex == 1 }" @click="sex = 1">男</div>
      <div :class="{ action: sex == 0 }" @click="sex = 0">女</div>
    </div>

    <div class="select-time">
      <span>出生日期</span>
      <div class="select-box" @click="showdate = true">
        <span>{{ date }}</span>
        <i class="iconfont icon-triangle-left"></i>
      </div>
    </div>
    <div class="select-time">
      <span>出生时辰</span>
      <div class="select-box" @click="showTime = true">
        <span>{{ time }}</span>
        <i class="iconfont icon-triangle-left"></i>
      </div>
    </div>
    <!-- <div class="option" @click="selectTime">
      <span>出生时辰：</span>
      <div class="option-con">
        <span class="placeholder">{{ time }}</span>
      </div>
      <i class="iconfont icon-a-LeftArrow"></i>
    </div> -->

    <div class="tips">
      <div>注：</div>
      <div>
        1.古代的重量单位:1斤=10量。本称骨算命为农历生辰算命。
        2.出生在夜11~12点,算第二天;闰月上半月算本月,下半月
        算下月。如闰月五月十四，作五月算;闰五月十六，作六月算。
      </div>
    </div>
    <div style="height: 3rem"></div>
    <div class="start-btn" @click="start">开始测算</div>
    <select-date
      v-model="showdate"
      :lunar="lunar"
      @confirm="dateConfirm"
      :date="date"
    />

    <select-time v-model="showTime" :lunar="lunar" :date="time" @confirm="timeConfirm" />
    <shareBottomComp v-if="share == 1"></shareBottomComp>
    </div>
  </div>

</template>

<script>
import topTab from "@/components/topTab";
import selectDate from "@/components/selectDate.vue";
import selectTime from "@/components/selectTime.vue";
import shareBottomComp from '@/components/shareBottomComp'
import { shareJsSdk,HERF, getQueryString } from "@/utils/tool";
/**
@description:称骨算命
@createTime:2021-08-25
@create:wq
*/
export default {
  name: "",
  props: {},
  components: { selectDate, selectTime ,shareBottomComp,topTab},
  data() {
    return {
      showdate: false,
      sex: 1,
      lunar: 0,
      date: "请选择出生年月日",
      showTime: false,
      time: "请选择出生时辰",
      share:0,
      rout:[{
        name:'首页',
        path:'/home'
      },{
        name:'称骨算命',
        path:'/cg'
      }]
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    if (getQueryString("share")) {
      this.share = 1;
    }else{
      this.share = 0
    }
    shareJsSdk('cg','称骨算命','','',HERF+'/image/1.png')
  },
  methods: {
    start() {
      if (this.date === "请选择出生年月日") {
        this.Toast("请选择日期");
        return;
      }
      if(this.date === '请选择出生时辰'){
        this.Toast("请选择时辰");
        return;
      }
      this.weighBone();
    },
    weighBone() {
      this.api.weighBone({ sex: this.sex, birthday: this.date,lunar:this.lunar ,time:this.time }).then((res) => {
        localStorage.setItem("result", JSON.stringify(res.data));
        this.$router.push("cgres");
      });
    },
    dateConfirm(data) {
      this.lunar = data.lunar;
      this.date = data.date;
    },
    timeConfirm(data) {
      this.time = data.date;
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  overflow: hidden;
  margin: 0 0.24rem;
}
.page-logo {
  width: 1.2rem;
  /* height: 1.2rem; */
  display: block;
  margin: 0.76rem auto;
}
.title {
  display: flex;
  align-items: center;

  font-size: 0.3rem;
  font-weight: 400;
  color: #f9647d;
  .title-line {
    width: 0.08rem;
    height: 0.34rem;
    background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
    border-radius: 0px 0.04rem 0.04rem 0px;
    margin-right: 0.1rem;
  }
}
.text {
  margin-top: 0.24rem;
  font-size: 0.24rem;
  font-weight: 400;
  color: #666666;
  p {
    text-indent: 2em;
  }
}
.sex {
  //   padding: 0 0.34rem;
  margin: 1rem 0 0.46rem;
  height: 0.8rem;
  border-radius: 0.4rem;
  box-sizing: border-box;
  background: #f0f0f0;
  overflow: hidden;

  font-size: 0.3rem;
  font-weight: 400;
  color: #666666;
  display: flex;
  > div {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .action {
    color: #ffffff;
    background: #4fd9d5;
  }
}
.select-time {
  margin: 0.26rem 0;
  display: flex;
  align-items: center;
  > span {
    font-size: 0.3rem;
    font-weight: 400;
    color: #666666;
    margin-right: 0.38rem;
  }
  .select-box {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.24rem 0 0.44rem;
    border-radius: 0.5rem;
    background: #f0f0f0;
    border: 1px solid #e6e6e6;
    height: 0.76rem;
    span {
      font-size: 0.24rem;
      font-weight: 500;
      color: #cccccc;
    }
    i {
      font-size: 0.28rem;
      color: #53cedc;
    }
  }
}
.tips {
  margin-top: 0.7rem;
  display: flex;
  font-size: 0.24rem;
  font-weight: 400;
  color: #999999;
}

.start-btn {
  width: 7rem;
  height: 0.88rem;
  background: #4fd9d5;
  border-radius: 0.54rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 1.2rem;
  left: 50%;
  transform: translateX(-50%);

  font-size: 0.3rem;
  font-weight: 400;
  color: #ffffff;
}
</style>
